import store from "@/store";
import {Brands} from "@/brand/brandConfig";
import WorldPlayService from "@/services/worldPlayService";
import cleanMtnUser from "@/functions/cleanMtnUser";
import PredictorService from "@/services/predictorService";
import {leagueXiService} from "@/config";
import {handleMyBundleEntry, isMyBundleEntry} from "@/functions/myBundleEntry";

export async function userAuthenticate(to, from, next) {
    const {brand} = store.state.brandConfig;
    if (brand === Brands.MTNWorldPlaySouthAfricaEnglish) await userAuthenticateWorldPlay(to, from, next)
    else if (brand === Brands.WorldPlaySouthAfricaEnglish) await userAuthenticateWorldPlay(to, from, next)
    else await userAuthenticateWorldPlay(to, from, next);
}

async function userAuthenticateWorldPlay(to, from, next) {
    if (store.state.user) {
        store.commit('setIsLoading', false);
        return next();
    }

    if (isMyBundleEntry()) return await myBundleEntryFlow(to, next);

    const allowedRoutes = ['TermsAndConditions'];
    if (allowedRoutes.includes(to.name)) return next();

    const urlParams = new URLSearchParams(window.location.search);
    const {productId} = store.state.brandConfig;
    const wpMsisdn = urlParams.get('tn');
    const urlMsisdn = urlParams.get('msisdn') ?? localStorage.getItem('msisdn');
    let msisdn = wpMsisdn ? wpMsisdn : urlMsisdn;

    // Localhost auth bypass — use mock msisdn for development
    if (!msisdn && window.location.origin.includes('localhost')) {
        msisdn = '27844696041';
    }

    if (!msisdn) {
        window.open(leagueXiService.subscribeUrl, '_self');
        return next();
    }

    localStorage.setItem('msisdn', msisdn);
    let getUser;
    try {
        getUser = await WorldPlayService.getUser(msisdn, productId);
    } catch (e) {
        console.error('Error fetching user:', e);
    }

    if (!getUser || typeof getUser !== 'object') {
        console.warn('Invalid user response:', getUser);
        window.open(leagueXiService.subscribeUrl, '_self');
        return next();
    }

    const userData = {
        ...getUser,
        msisdn: getUser.Msisdn,
    };
    const testMsisdn = '27712866546';
    if (`${msisdn}` === `27603807829` || (`${msisdn}` === testMsisdn && urlParams.get('msisdn') === testMsisdn)) {
        getUser.Status = 'active'
    }
    const cleanedUser = cleanMtnUser(userData);
    const validUser = getUser.Status && (getUser.Status.toLowerCase() === 'pending' || getUser.Status.toLowerCase() === 'active');

    if (validUser) {
        await setUserData(cleanedUser, next, to);
    } else {
        window.open(leagueXiService.subscribeUrl, '_self');
        return next();
    }
}

async function myBundleEntryFlow(to, next) {
    store.commit('setIsLoading', true);
    const entry = await handleMyBundleEntry(store.state.brandConfig.productId);
    if (!entry.entered) {
        store.commit('setIsLoading', false);
        window.open(leagueXiService.subscribeUrl, '_self');
        return next();
    }
    return await setUserData(entry.user, next, to);
}

async function setUserData(user, next, to) {
    store.commit('setMsisdn', user.msisdn);
    store.commit('setServiceId', user.serviceId);
    store.commit('setUser', user);
    store.commit('setIsLoading', false);
    await setPredictorUserData(to, user.msisdn);
    return next();
}

async function setPredictorUserData(to, msisdn) {
    const allowedPaths = ['/predictor/upcoming-rounds', '/predictor/my-rounds'];
    if (!allowedPaths.includes(to.path)) return;
    const response = await PredictorService.getUserStats(msisdn);
    store.commit('setPredictorUserStats', response);
}
